import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom'; // Import Link from react-router-dom
import { patchApi, putApi } from '../../../Services/apiService';
import { removeLeadingSpaces } from '../../../Utils/utils';

const EditUserModal = ({ setEditUserModal, userDetails }) => {
    console.log('this is user details', userDetails);
    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };
    const navigate = useNavigate();
    const [lastName, setLastName] = useState(userDetails?.last_name || '');
    const [firstName, setFirstName] = useState(userDetails?.first_name || '');
    const [password, setPassword] = useState('******');
    const [id, setId] = useState(userDetails?.id || '');
    const [email, setEmail] = useState(userDetails?.email || '');
    const [imagePreview, setImagePreview] = useState(userDetails?.image || null); // State to store the image preview URL
    const [imageFile, setImageFile] = useState(null); // State to store the image file
    const [loader, setLoader] = useState(false);
    const [showPassword, setShowPassword] = useState(false);


    const [errors, setErrors] = useState({ lastName: '', firstName: '', email: '', password: '' })
    const closeModal = () => {
        setEditUserModal(true);
    };



    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file); // Save the file for later use
            setImagePreview(URL.createObjectURL(file)); // Set image preview
        }
    };

    const validateForm = () => {
        let validationErrors = {};

        // Validate required fields
        validationErrors.firstName = firstName ? '' : 'First Name is required';
        validationErrors.lastName = lastName ? '' : 'Last Name is required';
        // Email validation (uncomment if needed)
        if (email) {
            validationErrors.email = /\S+@\S+\.\S+/.test(email) ? '' : 'Invalid Email';
        } else {
            validationErrors.email = 'Email is required';
        }
        if (!password) {
            validationErrors.password = 'Password is required';
        }
        // Update the error state
        setErrors(validationErrors);

        // Return true if there are no errors
        return Object.values(validationErrors).every(error => error === '');
    };


    const handleSave = async () => {
        try {
            if (validateForm()) {
                setLoader(true);
                const data ={
                    first_name:firstName,
                    last_name:lastName,
                    email:email,
                    password:password === '******' ? '':password
                }
                const response = await patchApi(`/admin/user?id=${userDetails?.id}`, data);
                if (response.statusCode === 200) {
                    setLoader(false);
                    setEditUserModal(false)
                } else {
                    setLoader(false);
                    // Handle error
                }
            }
        }
        catch (error) {
            setLoader(false);
            console.error('Error submitting booking:', error);
        }
    };
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <>
            <div className='modal-header'>
                <h3>Edit User</h3>
                <button className='close-button' onClick={() => setEditUserModal(false)}><img src={window.getPublicUrl("/assets/images/gray-cross.svg")} alt='' /></button>

            </div>
            <div className='modal-body'>
                {/* <div className='input-main'>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <div className="custom-floating-group">
                                <div className="setting-img basic-setting">
                                    <div className="setting-profile">
                                        <img src={imagePreview || window.getPublicUrl('/assets/images/dummy-profile.jpg')} alt="Profile Preview" className="profile-preview" />
                                    </div>
                                    <div className="upload-btn-wrapper">
                                        <input type="file" name="myfile" onChange={handleImageChange} />
                                        <button className="btn">Upload photo</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className='input-main'>
                    <div className='row'>
                        <div className='col-sm-6'>
                            <div className={`custom-floating-group `}>
                                <input type="text" placeholder=" " value={firstName} maxLength={30} onChange={(e) => {
                                    const value = e.target.value;
                                    setFirstName(removeLeadingSpaces(value));
                                }}
                                />
                                <label>First Name</label>
                                {errors.firstName && <div className="error">{errors.firstName}</div>}
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className={`custom-floating-group `}>
                                <input type="text" placeholder=" " value={lastName} maxLength={30}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setLastName(removeLeadingSpaces(value));
                                }}
                                />
                                <label htmlFor="name">Last Name</label>
                                {errors.lastName && <div className="error">{errors.lastName}</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='input-main'>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <div className={`custom-floating-group `}>
                                <input disabled type="text" placeholder=" " value={email}
                                 onChange={(e) => {
                                    const value = e.target.value;
                                    setEmail(removeLeadingSpaces(value));
                                }}
                                />
                                <label>Email</label>
                                {errors.email && <div className="error">{errors.email}</div>}
                            </div>
                        </div>
                        
                    </div>
                </div>

                <div className='input-main'>
                    <div className='row'>
                    <div className='col-sm-6'>
                            <div className={`custom-floating-group `}>
                            <input
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder=" "
                                    value={password}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setPassword(removeLeadingSpaces(value));
                                    }}
                                />
                                <label>Reset Password</label>
                                {errors.password && <div className="error">{errors.password}</div>}
                                <span className="eye-icon" onClick={togglePasswordVisibility}>
                                    <img src={showPassword ? window.getPublicUrl("/assets/images/Eye.svg") : window.getPublicUrl("/assets/images/Eye-closed.svg")} alt="Toggle Password" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='modal-footer'>
                <button onClick={() => setEditUserModal(false)}>Cancel</button>
                <button className='save' onClick={() => handleSave()} disabled={loader}>
                    {loader && <div className="spinner-border" role="status"><span className="sr-only"></span></div>}
                    Save</button>
            </div>
        </>
    );
}

export default EditUserModal;